import { render, staticRenderFns } from "./OsLanguageSelection.vue?vue&type=template&id=37ee81eb&scoped=true"
import script from "./OsLanguageSelection.vue?vue&type=script&lang=ts"
export * from "./OsLanguageSelection.vue?vue&type=script&lang=ts"
import style0 from "./OsLanguageSelection.vue?vue&type=style&index=0&id=37ee81eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ee81eb",
  null
  
)

export default component.exports